import { axios } from 'shared/services/axios'

export function createCalendarLinks({boardId, leadData}) {
  return axios.post('/live_board/v2/calendar_invites', {
      board_id: boardId,
      lead_data: leadData
    })
    .then(response => response.data)
}